import React from "react";

import { useHistory } from "react-router-dom";

import { Dialog } from "primereact";
import Lottie from "react-lottie";

import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form-factory";
import ResumeInvoice from "../../../../components/resume-invoice";
import TemplateInvoice from "../../../../components/template-invoice";

import { Fields } from "./fields";

import { CNAESModel } from "../../../../../domain/models/cnae";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";

import { theme } from "../../../../styles/theme";
import * as animationData from "../../../../assets/animations/loading.json";
import { CardContent, Wrapper } from "./styles";

import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";

type PageProps = {
  loading: boolean;
  handleSubmit: (
    values: any,
    setShowConfirm: any,
    setShowPreview: any,
  ) => Promise<void>;
  cnaesList: CNAESModel[];
  developerCompaniesList: DeveloperCompanyModel[];
};

const isSmallScreen = window.innerWidth < 768;

const InvoiceForm: React.FC<PageProps> = ({
  loading,
  handleSubmit,
  cnaesList,
  developerCompaniesList,
}) => {
  const history = useHistory();

  const [currentNote, setCurrentNote] = React.useState<any>();
  const [showResume, setShowResume] = React.useState<boolean>(false);
  const [showConfirm, setShowConfirm] = React.useState<boolean>(false);
  const [showPreview, setShowPreview] = React.useState<boolean>(false);

  if (loading) <>loading...</>;

  const handleClose = (): void => {
    setShowResume(false);
    setShowPreview(false);
    history.push("/documents");
  };

  return (
    <Wrapper>
      <BackButtom text="Emitir Invoice" />

      <CardContent>
        <FormFactory
          groups={Fields(cnaesList, developerCompaniesList)}
          enbaleCountGroup
          onSubmit={async (values: any, actions: any) => {
            try {
              const countriesData = await makeRemoteAddresss().loadCountries();
              const country = countriesData.find(
                (el) => el.id === values.country,
              );
              const developerCompany = developerCompaniesList.find(
                (el) => el.company?.id === values.company,
              )?.company;
              setCurrentNote((prev: any) => ({
                ...prev,
                ...values,
                country,
                cnae: cnaesList.find((el) => el.id === values?.cnaes),
                developerCompany,
              }));
              setShowResume(true);
              actions.setSubmitting(false);
            } catch (error) {
              actions.setSubmitting(false);
            }
          }}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: false,
            onClick: () => history.goBack(),
            backgroundColor: theme.colors.darkBlue,
          }}
          button={{
            submit: "Gerar Invoice",
            submitting: "Gerando...",
            hide: false,
            backgroundColor: theme.colors.blue400,
            color: theme.colors.white,
          }}
        />
      </CardContent>
      <Dialog
        header="Resumo do Invoice:"
        visible={showResume}
        style={{
          width: isSmallScreen ? "90vw" : "60vw",
          backgroundColor: theme.colors.darkBlue,
        }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        footer={null}
        onHide={() => setShowResume(false)}
      >
        <ResumeInvoice
          invoice={currentNote}
          onConfirmCallback={async () => {
            await handleSubmit(currentNote, setShowConfirm, setShowPreview);
            setShowResume(false);
          }}
          onCancelCallback={() => setShowResume(false)}
        />
      </Dialog>
      <Dialog
        header="Invoice:"
        visible={showPreview}
        style={{
          width: isSmallScreen ? "90vw" : "60vw",
          backgroundColor: theme.colors.darkBlue,
        }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        footer={null}
        onHide={handleClose}
      >
        <TemplateInvoice invoice={currentNote} onCancelCallback={handleClose} />
      </Dialog>
      <Dialog
        header="Aguarde!"
        visible={showConfirm}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        style={{
          width: isSmallScreen ? "90vw" : "35vw",
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        footer={null}
        onHide={() => null}
        closable={false}
      >
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={20}
          width={100}
          isStopped={false}
          isPaused={false}
        />
        <p className="text-center mt-4" style={{ maxWidth: "100%" }}>
          Invoice sendo gerada. Logo você poderá fazer o download do documento.
        </p>
      </Dialog>
    </Wrapper>
  );
};
export default InvoiceForm;
